<template>
  <div v-if="ui.loading">
    <div id="overlay" data-testid="v3-loading">
      <div class="flex items-center justify-center w-full h-full">
        <div class="content-loading">
          <img
            src="~/assets/svg/icon-loading2.svg"
            alt="loading"
            width="300"
            height="300"
            class="mx-auto"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// components/v3/App/LoadingOverlay.vue — port of components/Global/Loading.vue (SPEC §9).
import { useUiStore } from '~/store/v3/ui'

const ui = useUiStore()
</script>

<style scoped>
#overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #000000a8;
  z-index: 999;
  border: 0px;
}
</style>
